import {
  BackgroundColors,
  PositiveColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    wrapper: {
      width: '100%',
      height: 154,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: Spacings.s8,
      borderRadius: CornerRadius.r16,
      border: [1, 'solid', BackgroundColors.tint3],
      backgroundColor: BackgroundColors.base,
      color: PositiveColors.text.default,
      padding: [Spacings.s24, Spacings.s16],
      transition: 'all .3s ease',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: `${Spacings.s0} ${Spacings.s0} ${Spacings.s16} ${Spacings.s0} rgba(0,0,0,0.2)`,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s4,
    },
    img: {
      width: 170,
      height: 114,
      objectFit: 'contain',
    },
    button: {
      height: 32,
      width: 152,
      marginTop: Spacings.s10,
      display: 'flex',
      justifyContent: 'start',
      padding: Spacings.s0,
    },
    description: {
      fontSize: FontSizes.s12,
      color: TextColors.tint1,
    },
    title: {
      fontSize: FontSizes.s20,
    },
    // Skeleton
    skeletonWrapper: {
      extend: 'wrapper',
      borderRadius: CornerRadius.r16,
    },
  },
  {
    name: 'similar-page-item',
  },
);

export default useStyles;
